export class ReturnTo {
  currentUrl: string;
  returnTo: string | null;

  constructor(currentUrl: string) {
    this.currentUrl = currentUrl;
    this.returnTo = new URL(currentUrl).searchParams.get("return_to");
  }

  addReturnToParam(path: string) {
    const currentUrl = new URL(this.currentUrl);
    const origin = currentUrl.origin;
    const url = new URL(`${origin}${path}`);
    url.searchParams.set("return_to", `${currentUrl.pathname}${currentUrl.search}`);
    return `${url.pathname}${url.search}`;
  }

  returnToUrl() {
    const currentUrl = new URL(this.currentUrl);
    const origin = currentUrl.origin;

    if (this.returnTo) {
      try {
        const returnToUrl = `${origin}${this.returnTo}`;

        // validate
        if (new URL(returnToUrl).origin !== origin) {
          return null;
        }

        return returnToUrl;
      } catch {
        return null;
      }
    } else {
      return null;
    }
  }
}
